import { takeLatest } from "redux-saga/effects";

import { LOGIN } from "../actions/actionTypes";
import { LoginRequest } from "./authSaga";


function* rootSaga() {
    yield takeLatest(LOGIN, LoginRequest);
}

export default rootSaga;
